import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ISalaryComponent } from '../../interfaces/payroll.interface';

interface Props {
    open: boolean;
    onClose: () => void;
    onSave: (data: Partial<ISalaryComponent>) => void;
    component: ISalaryComponent | null;
}

const SalaryComponentForm: React.FC<Props> = ({ open, onClose, onSave, component }) => {
    const { t } = useTranslation(['payroll', 'common']);
    const [name, setName] = useState('');
    const [type, setType] = useState<'EARNING' | 'DEDUCTION'>('EARNING');
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        if (component) {
            setName(component.name);
            setType(component.type);
            setIsActive(component.isActive);
        } else {
            setName('');
            setType('EARNING');
            setIsActive(true);
        }
    }, [component, open]);

    const handleSubmit = () => {
        onSave({ name, type, isActive });
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{component ? t('salaryComponentForm.titleEdit') : t('salaryComponentForm.titleAdd')}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={t('salaryComponentForm.name')}
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ mb: 2, mt: 1 }}
                />
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>{t('common:fields.type')}</InputLabel>
                    <Select value={type} label={t('common:fields.type')} onChange={(e) => setType(e.target.value as any)}>
                        <MenuItem value="EARNING">{t('salaryComponentForm.earning')}</MenuItem>
                        <MenuItem value="DEDUCTION">{t('salaryComponentForm.deduction')}</MenuItem>
                    </Select>
                </FormControl>
                <FormControlLabel
                    control={<Switch checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
                    label={t('common:status.active')}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('common:actions.cancel')}</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={!name.trim()}>
                    {t('common:actions.save')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SalaryComponentForm;
